import { render, staticRenderFns } from "./OlympiadBanner.vue?vue&type=template&id=0eda0496&scoped=true&lang=pug&"
import script from "./OlympiadBanner.vue?vue&type=script&lang=js&"
export * from "./OlympiadBanner.vue?vue&type=script&lang=js&"
import style0 from "./OlympiadBanner.vue?vue&type=style&index=0&id=0eda0496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda0496",
  null
  
)

export default component.exports